import { defineMessages } from 'react-intl-next';

export const i18n: {
	positionFilterJobFamilyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterJobFamilyPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterJobFamilyLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterJobFamilyLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionFilterJobFamilyLabel: {
		id: 'search-page.filters.names.positionJobFamily',
		defaultMessage: 'Job family',
		description: 'Label for filtering by job family',
	},
	positionFilterJobFamilyPlaceholder: {
		id: 'search-page.talent.filter.position-job-family.content.placeholder',
		defaultMessage: 'Find job families',
		description: 'Placeholder for job family filter search input',
	},
	positionFilterJobFamilyLabelSelected: {
		id: 'search-page.talent.filter.position-job-family.content.selected',
		defaultMessage: 'Selected',
		description: 'Job family filter content selected',
	},
	positionFilterJobFamilyLabelUnselected: {
		id: 'search-page.talent.filter.position-job-family.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Job family filter content unselected',
	},
});
